import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useServices } from "../../data/services";
import Card from "../card/Card";

const Dashboard = () => {
    const { t } = useTranslation();
    const user = useSelector((state) => state.auth.user);
    const availableApps = user?.profile?.available_app || [];
    const services = useServices(availableApps);
    const profile = process.env.REACT_APP_PROFILE || "aenduo";
    const welcomeMessage = t(`welcome_${profile}`);

    return (
        <div className="d-flex flex-column min-vh-100">
            <Header />
            <main className="flex-grow-1 p-5">
                <div className="text-primary fw-bold fs-1 display-4">{welcomeMessage}</div>
                <p className="my-2 mb-lg-4 text-secondary fs-4">{t("description")}</p>
                <div className="row gx-4 gy-4 mt-4">
                    {services.map((service, index) => (
                        <div className="col-md-6 col-lg-3" key={index}>
                            <Card
                                icon={service.icon}
                                title={service.title}
                                description={service.description}
                                link={service.link}
                            />
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Dashboard;
